import { createContextualCan } from '@casl/react';
import ability from 'lib/ability';
import { createContext } from 'react';

export const AbilityContext = createContext(ability);
export const Can = createContextualCan(AbilityContext.Consumer);
